export default "__VITE_ASSET__84efd208__"